export default {
  l10n: {
    currency: '\u20ac',
    date: {
      months: {
        full: [
          'january',
          'february',
          'march',
          'april',
          'may',
          'june',
          'july',
          'august',
          'september',
          'october',
          'november',
          'december',
        ],
        abbr: [
          'jan',
          'feb',
          'mar',
          'apr',
          'may',
          'jun',
          'jul',
          'aug',
          'sep',
          'oct',
          'nov',
          'dec',
        ],
      },
      days: {
        full: [
          'sunday',
          'monday',
          'tuesday',
          'wednesday',
          'thursday',
          'friday',
          'saturday',
        ],
        abbr: ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'],
      },
      patterns: {
        longDate: 'dddd, MMMM D, YYYY',
        dateSlash: 'MM/DD/YYYY',
        dateShort: 'dddd, MMMM D',
        dateShortWithDay: 'Do MMMM YYYY',
        dateMedium: 'dddd, MMMM D - h[:]mm a',
        dateMediumReversed: 'H[:]mm - D MMMM YYYY',
        dateMediumSlash: 'DD[/]MM[/]YYYY H[:]mm a',
        dateLarge: 'D MMM YYYY h[:]mm a',
        timeShort: 'LT',
        timeMedium: 'DD[/]MM LT',
      },
    },
    number: {
      patterns: {
        standard: ['-n', 'n'],
        amount: ['(Sn)', 'Sn'],
      },
      group: {
        separator: ',',
        length: 3,
        abbr: ['', 'k', 'M', 'B'],
      },
      decimal: {
        separator: '.',
        length: 2,
      },
      ordinal: function (number) {
        var b = number % 10;
        return (
          number +
          ((number % 100) / 10 === 1
            ? 'th'
            : b === 1
            ? 'st'
            : b === 2
            ? 'nd'
            : b === 3
            ? 'rd'
            : 'th')
        );
      },
    },
  },
  translations: {
    messages: {
      Cart: [null, 'Cart'],
      Filters: [null, 'Filters'],
    },
  },
};
